import { initializeApp, getApps } from "firebase/app";
import { getAuth } from "firebase/auth";
import { initializeFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const getEnv = (key: string) => {
  try {
    const meta = import.meta as any;
    if (meta?.env?.[key]) return meta.env[key];
  } catch {}

  try {
    if (typeof process !== "undefined" && (process as any)?.env?.[key]) {
      return (process as any).env[key];
    }
  } catch {}

  return undefined;
};

const firebaseConfig = {
  apiKey: getEnv("VITE_FIREBASE_API_KEY") || "AIzaSyANmypryEuL6aq3wfVMBHtlfHLz1DBuQQA",
  authDomain: getEnv("VITE_FIREBASE_AUTH_DOMAIN") || "filers-hub-dev.firebaseapp.com",
  projectId: getEnv("VITE_FIREBASE_PROJECT_ID") || "filers-hub-dev",
  storageBucket: getEnv("VITE_FIREBASE_STORAGE_BUCKET") || "filers-hub-dev.firebasestorage.app",
  messagingSenderId: getEnv("VITE_FIREBASE_MESSAGING_SENDER_ID") || "741162396862",
  appId: getEnv("VITE_FIREBASE_APP_ID") || "1:741162396862:web:260fe99baabe05e29582ef",
};

const app = getApps().length ? getApps()[0] : initializeApp(firebaseConfig);

export const auth = getAuth(app);

export const db = initializeFirestore(app, {
  experimentalForceLongPolling: true,
});

export const storage = getStorage(app);
